import { Filter } from "lucide-react";
import { TableCell, TableRow } from "../../../../components/ui/table";

export const WorkStepsEmptyRow = ({ colSpan }: { colSpan: number }) => (
  <TableRow>
    <TableCell colSpan={colSpan} className="text-center py-12 border-x">
      <div className="text-stone-500">
        <Filter className="mx-auto h-12 w-12 mb-4 opacity-50" />
        <p className="text-lg font-medium mb-2">No work steps found</p>
        <p className="text-sm">Try adjusting your filters or search terms</p>
      </div>
    </TableCell>
  </TableRow>
);
